export default "__VITE_ASSET__Q$wxH8BC__"